import {combineReducers} from 'redux';
import Definition from 'routes/Home/Attendance/Shift/Definition/Module';
import Assignment from 'routes/Home/Attendance/Shift/Assignment/Module';

const reducers = combineReducers({
  Definition,
  Assignment,
});

export default reducers;
